module.exports = __webpack_public_path__ + "img/greetPop.89e0d337.jpg";